import { Theme, css, useTheme } from '@emotion/react';

import type { DeliveryTime as DeliveryTimeType } from 'api/api';

import { DeliveryType, getDeliveryTimeText } from '~src/commons/utils/delivery-time';
import { getDeliveryTimeText as shortGetDeliveryTimeText } from '~src/commons/utils/short-delivery-times';
import { useTranslations } from '~src/commons/utils/translations/translate';
import { useGlobalState, useSessionState } from '~src/global-state';
import { fontStyles } from '~src/theme/fontStyles';

import { Text } from '../commons/components';

type DeliveryTimeProps = {
  deliveryTime: DeliveryTimeType;
  type: DeliveryType;
};

export const DeliveryTime = ({ type, deliveryTime }: DeliveryTimeProps) => {
  const { tICU, formatDate, locale } = useTranslations();
  const {
    flags: {
      enable_short_delivery_times,
      show_delivery_times_as_estimates,
      alter_ics_delivery_message,
    },
  } = useSessionState();
  const state = useGlobalState();
  const theme = useTheme();

  return (
    <div data-test="delivery-time" css={styles.titleContent}>
      <Text css={styles.title} textStyle={styles.titleText(theme)} color="neutral35">
        {enable_short_delivery_times
          ? shortGetDeliveryTimeText({
              deliveryTime,
              translate: tICU,
              format: formatDate,
              locale,
              additional: { showDeliveryTimeAsEstimate: !!show_delivery_times_as_estimates },
            })
          : getDeliveryTimeText(deliveryTime, type, tICU, formatDate, locale, {
              isTomorrowHoliday: !!state.additional?.is_tomorrow_holiday,
              purchaseCountry: state.purchase_country,
              showDeliveryTimeAsEstimate: !!show_delivery_times_as_estimates,
              alterIcsDeliveryTimeMessage: !!alter_ics_delivery_message,
            })}
      </Text>
    </div>
  );
};

const styles = {
  titleContent: css({ whiteSpace: 'initial' }),
  title: css({
    display: 'inline',
    width: '100%',
  }),
  titleText: (theme: Theme) =>
    css({
      color: theme.neutral35,
      fontStyle: 'normal',
      ...fontStyles.px14_20,
      fontVariationSettings: "'wght' 400",
      textTransform: 'none',
      letterSpacing: 0,
    }),
};
